import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { routes } from "./routing/routes";

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false, // <-- enable debug only
    }),
  ],
  exports: [
    RouterModule,
  ],
})
export class AppRoutingModule {}
